<template>
  <Drawer slideout-id="registry-slideout" :provider="useRegistrySlideout" @close-slideout="handleRegistryCloseClick">
    <RegistryContent />
  </Drawer>
</template>

<script setup>
import Drawer from '~/components/common/Drawer.common';
import useRegistrySlideout from '~/composables/features/useRegistrySlideout';
import RegistryContent from '~/components/registry/RegistryContent.common';
import { fireLinkTag } from '#shared/features/analytics/tagManager';

function handleRegistryCloseClick() {
  fireLinkTag({
    event_name: 'registry drawer close',
    link_name: 'registry drawer close',
  });
}
</script>

<style lang="scss">
#registry-slideout {
  width: 428px;
}
</style>
